import { render, staticRenderFns } from "./announCList.vue?vue&type=template&id=134a2473"
import script from "./announCList.vue?vue&type=script&lang=js"
export * from "./announCList.vue?vue&type=script&lang=js"
import style0 from "./announCList.vue?vue&type=style&index=0&id=134a2473&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports